<template>
  <div class="c-i-content">
    <div class="c-i-left">
      <div class="type-list">
        <div
          class="type-item"
          v-for="(item, index) in recommendTotalData"
          :key="index"
        >
          <div
            class="item-line"
            :style="{ background: colorData[item.name].color1 }"
          ></div>
          <div class="item-name">{{ item.name }}</div>
          <div class="item-dash"></div>
          <div class="item-num">{{ item.weight }}</div>
          <div class="item-unit">g</div>
        </div>
      </div>
    </div>
    <div class="c-i-right">
      <CircleEcharts />
    </div>
  </div>
</template>
<script>
import { recommendTotalData, colorData } from '../data.js'
import CircleEcharts from './circle.vue'
export default {
  components: { CircleEcharts },
  data() {
    return {
      recommendTotalData: recommendTotalData,
      colorData: colorData
    }
  }
}
</script>
<style lang="scss" scoped>
.c-i-content {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .c-i-left {
    width: 140px;

    .type-list {
      .type-item {
        display: flex;
        align-items: center;
        margin-bottom: 13px;

        .item-line {
          width: 3px;
          height: 14px;
          background-color: rgba(161, 219, 240, 1);
          margin-right: 10px;
        }

        .item-name {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
          margin-right: 2px;
        }

        .item-dash {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          height: 0;
          border-bottom: 2px dashed rgba(103, 105, 255, 0.5);
          margin-right: 2px;
        }

        .item-num {
          font-size: 20px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
          margin-right: 4px;
        }

        .item-unit {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
        }
      }

      .type-item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .c-i-right {
    width: 106px;
    height: 106px;
  }
}
</style>
